module.exports = __webpack_public_path__ + "static/media/ServiceOrderTemplate2.6ef96df8.png";